<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAndroidLogo_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M11.402 9.23a.615.615 0 1 1 0-1.23.615.615 0 0 1 0 1.23Zm-6.796 0a.615.615 0 1 1 0-1.23.615.615 0 0 1 0 1.23Zm7.016-3.704 1.229-2.128a.256.256 0 1 0-.443-.256l-1.244 2.155a7.584 7.584 0 0 0-3.16-.676 7.59 7.59 0 0 0-3.16.676L3.6 3.142a.256.256 0 1 0-.443.256l1.229 2.128a7.255 7.255 0 0 0-3.764 5.807h14.764a7.256 7.256 0 0 0-3.764-5.807Z"
    />
</svg>
